import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { verifyPolicy as policyVerification } from '../../../utils/apiService';

import BlankState from '../../../components/BlankState';
import Page from '../../../components/Page';
import Panel from '../../../components/Panel';

class VerifyPolicy extends Component {
  constructor(props) {
    super(props);

    this.state = {
      policy: null,
      policy_number: '',
      is_verifying: false
    };

    this.verifyPolicy = this.verifyPolicy.bind(this);
  }

  onChange = e => {
    const { name, value } = e.target;

    this.setState({
      [name]: value
    });
  };

  verifyPolicy() {
    this.setState({
      is_verifying: true
    });

    policyVerification(this.state.policy_number)
      .then(res => {
        if (res.status === 200 && res.statusText === 'OK') {
          this.setState({
            policy: res.data,
            is_verifying: false
          });
        }
      })
      .catch(err => {
        this.setState({
          is_verifying: false,
          errorMessage: 'No Policy with that Identifier Found',
          error: true
        });
      });
  }

  render() {
    const { is_verifying, policy, errorMessage, error } = this.state;

    return (
      <Page isAdminPage={true} pageTitle="Verify Policy">
        <div className="col-sm-9">
          <Panel title="Enter endorsement number to verify policy:">
            <div className="form form-inline">
              <input
                type="text"
                className="form-control"
                name="policy_number"
                placeholder="E.g. Policy number"
                onChange={this.onChange}
                id="ed_number"
                style={{ width: '80%' }}
                autoFocus
              />
              <button className="btn btn-warning" onClick={this.verifyPolicy}>
                <i className="icon ion-eye" />Verify Policy
              </button>
            </div>
            <hr />

            {is_verifying ? (
              <BlankState
                dataName="Policy details"
                isDataLoading={is_verifying}
              />
            ) : (
              <div className="clearfix">
                {policy ? (
                  <div className="clearfix">
                    <h3>
                      Status: <span className="text-success">Verified</span>
                    </h3>

                    <p>Policy Info</p>
                    <table
                      id="policy_info"
                      className="table table-striped table-responsive"
                    >
                      <tr>
                        <td>Name of Insured</td>
                        <td>{policy.proposer_name}</td>
                      </tr>
                      <tr>
                        <td>Policy Number</td>
                        <td>{policy.policy_number}</td>
                      </tr>
                      <tr>
                        <td>ICC Class</td>
                        <td>{policy.institute_cargo_clause}</td>
                      </tr>
                      <tr>
                        <td>Insurer</td>
                        <td>{policy.insurer_name}</td>
                      </tr>
                      <tr>
                        <td>Sum Insured</td>
                        <td>{policy.total_sum_insured}</td>
                      </tr>
                    </table>
                  </div>
                ) : (
                  <div className="clearfix">
                    {error ? (
                      <div className="alert alert-danger" role="alert">
                        {errorMessage}
                      </div>
                    ) : null}
                  </div>
                )}
              </div>
            )}
          </Panel>
        </div>
      </Page>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.user
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators({}, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VerifyPolicy);



// WEBPACK FOOTER //
// ./src/pages/dashboard/policies/VerifyPolicy.jsx